import { computed, Injectable, signal } from "@angular/core";

interface LoadingTokenData {
  token: string;
  message?: string;
}

@Injectable({
  providedIn: "root",
})
export class LoadingService {
  private loadingTokens = signal<Set<LoadingTokenData>>(new Set());

  message = computed(() => {
    const tokens = Array.from(this.loadingTokens());
    if (tokens.length === 0 || !tokens[0].message) {
      return "Loading";
    }
    return tokens[0].message;
  });
  isLoading = computed(() => this.loadingTokens().size > 0);

  start = (token: LoadingTokenData): void => {
    this.loadingTokens.update((tokenSet) => {
      const exists = Array.from(tokenSet).some((t) => t.token === token.token);
      if (!exists) {
        const next = new Set(tokenSet);
        next.add(token);
        return next;
      }
      return tokenSet;
    });
  };

  stop = (token: string): void => {
    this.loadingTokens.update((tokenSet) => {
      const next = new Set(tokenSet);
      for (const t of next) {
        if (t.token === token) {
          next.delete(t);
          break;
        }
      }
      return next;
    });
  };
}
